import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';

interface InputBooleanFormikProps {
  formik: any;
  label: string;
  labelTexto: string;
  exposeChange?: (value: boolean) => void;
  textBold?: boolean;
  marginBottom?: string;
}
const InputBooleanFormik: React.FC<InputBooleanFormikProps> = ({
  formik,
  label,
  labelTexto,
  textBold = true,
  marginBottom = '0rem',
  exposeChange,
}) => {

  const checkRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(label, e.target.value === 'true');
    exposeChange?.(e.target.value === 'true');
  }

  return (
    <FormControl sx={{ marginBottom }}>
      <FormLabel
        id={`${label}-label`}
        htmlFor={`${label}-radio-group`}
        sx={{
          color: '#333',
          fontWeight: textBold ? 'bold' : 'normal',
        }}
        error={formik.errors[label] ? true : false}
      >
        {labelTexto}
        {formik.errors[label] && (
          <FormHelperText error>{formik.errors[label]}</FormHelperText>
        )}
      </FormLabel>

      <RadioGroup
        id={`${label}-radio-group`}
        aria-labelledby={`${label}-label`}
        defaultValue={formik.values[label]}
        name='radio-buttons-group'
        value={formik.values[label]}
        onChange={checkRadio}
      >
        <FormControlLabel value={true} control={<Radio />} label='Sim' />
        <FormControlLabel value={false} control={<Radio />} label='Não' />
      </RadioGroup>
    </FormControl>
  );
};

export default InputBooleanFormik;
